/**
 * Hiển thị cột ngày, số chứng từ gốc
 */
export default {
  None: 'none', // Không hiển thị
  NoneWhenInvoice: 'none_when_invoice', // Không hiển thị khi có số hóa đơn
  DateAndRefNoOld: 'date_and_ref_no_old', // Hiển thị ngày, số chứng từ gốc
  DateAndRefNo: 'date_and_ref_no', // Hiển thị ngày, số chứng từ
};
